import dfgViewerButtonPlugin from '@mdz/mirador-dfgviewerbutton'
import pdfDafoDownloadDialogPlugin from '@mdz/mirador-downloaddialog-pdfdafo/es'
import canvasLinkPlugin from 'mirador-canvaslink/es'
import canvasNavigationPlugin from 'mirador-canvasnavigation/es'
import { miradorImageToolsPlugin as imageToolsPlugin } from 'mirador-image-tools/es'
import imageCropperPlugin from 'mirador-imagecropper/es'
import keyboardShortcutsPlugin from 'mirador-keyboardshortcuts/es'
import textOverlayPlugin from 'mirador-textoverlay/es'

import MdzManifestInfo from './components/MdzManifestInfo'
import MdzSearchPanelControls from './components/MdzSearchPanelControls'
import MdzWindowSideBarInfoPanel from './components/MdzWindowSideBarInfoPanel'
import MdzWorkspaceControlPanelButtons from './components/MdzWorkspaceControlPanelButtons'
import rootSaga from './sagas'

const plugins = [
  ...canvasLinkPlugin,
  ...canvasNavigationPlugin,
  ...dfgViewerButtonPlugin,
  ...imageCropperPlugin,
  ...imageToolsPlugin,
  ...keyboardShortcutsPlugin,
  ...pdfDafoDownloadDialogPlugin,
  ...textOverlayPlugin,
  {
    saga: rootSaga,
  },
  {
    name: 'MdzManifestInfo',
    component: MdzManifestInfo,
    mode: 'wrap',
    target: 'ManifestInfo',
    config: {
      translations: {
        de: {
          description: 'Beschreibung',
          location: 'Standort',
        },
      },
    },
  },
  {
    name: 'MdzWindowSideBarInfoPanel',
    component: MdzWindowSideBarInfoPanel,
    mode: 'wrap',
    target: 'WindowSideBarInfoPanel',
  },
  // FIXME: remove this component override, as soon as Mirador renders the message taken from the error json
  {
    name: 'MdzSearchPanelControls',
    component: MdzSearchPanelControls,
    mode: 'wrap',
    target: 'SearchPanelControls',
  },
  {
    name: 'MdzWorkspaceControlPanelButtons',
    component: MdzWorkspaceControlPanelButtons,
    mode: 'wrap',
    target: 'WorkspaceControlPanelButtons',
  },
]

export default plugins
